module.exports = __webpack_public_path__ + "static/media/colored-circles.fe0587e8.png";